export const mondayUppercase = "qra";
export default {mondayUppercase};